export default "/build/images/ap.png?0be93956d1bb2b420e77ab2c9ae6e564";